import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

const ToastLight = css`
  background-color: rgba(255, 255, 255, 0.9);

  p,
  button {
    color: ${({ theme }) => theme.palette.primary.labels};
  }
`;

const ToastDark = css`
  background-color: rgba(0, 0, 0, 0.8);

  p,
  button {
    color: ${({ theme }) => theme.palette.system.white};
  }
`;

export const Toast = styled.div<{
  $isVisible: boolean;
  $isLight?: boolean;
}>`
  position: fixed;
  left: 50%;
  bottom: 35px;
  z-index: 100010;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 30px);
  max-width: 600px;
  height: 70px;
  padding: 0 15px;
  border-radius: 8px;
  touch-action: none;
  box-sizing: border-box;
  transition: transform 0.3s ease, opacity 0.3s ease;
  opacity: ${props => (props.$isVisible ? 1 : 0)};
  pointer-events: ${props => (props.$isVisible ? 'auto' : 'none')};
  transform: translate(-50%, ${props => (props.$isVisible ? 0 : '100%')});
  ${({ $isLight }) => ($isLight ? ToastLight : ToastDark)}
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  overflow: hidden;
`;

export const Image = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 7px;
  object-fit: cover;
  user-select: none;
`;

export const Text = styled(Typography.Body).attrs(() => ({ $variant: '4' }))`
  padding: 0;
  margin: 0;
  user-select: none;
  pointer-events: none;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: ${({ theme }) => theme.palette.system.white};
`;

export const Button = styled.button`
  font-size: 15px;
  background: none;
  text-decoration: underline;
  padding: 0;
  margin: 0;
  border: 0;
  cursor: pointer;
  outline: none;
  user-select: none;
  box-shadow: none;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  color: ${({ theme }) => theme.palette.system.white};
`;
